/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import List from "@mui/material/List";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WanderobeLogo from "../../../assets/images/wanderobe.svg";
import CustomButton from "../CustomButton";
import useNavigationHeaderStyles from "./useNavigationHeaderStyles";
import { HOME_PAGE } from "../../../constants/lang";
import { ROUTE_PATH } from "../../../constants/route";
import { BorderButton } from "../Button";
import {
  fetchGuestUserFlow,
  fetchLogout,
} from "../../../store/reducers/authentication/apiThunk";
import { fetchProfile } from "../../../store/reducers/home/apiThunk";
import { ToastNotifyError } from "../Toast/ToastNotify";
import { CUSTOM_BUTTON_OPTIONS } from "../../../constants/optionsConfig";
import { clearAllFav } from "../../../store/reducers/favourites";
import { useShoppingCart } from "../../../context/ShoppingCartContext";
import { useFavourite } from "../../../hooks/common-hooks/useFavourite";
import { resetBag } from "../../../store/reducers/bag/apiThunk";

function NavigationHeader(props) {
  const authentication = useSelector((state) => state.authentication);
  const [authenticationLogin, setAuthenticationLogin] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const styles = useNavigationHeaderStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserdetails, setTripDetails, setBagItems } = useShoppingCart();
  const [isScrolled, setIsScrolled] = useState(false);
  const bag = useSelector((state) => state?.Bag);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const auth_token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      "";
    if (auth_token) {
      setAuthenticationLogin(true);
      getProfile();
    } else {
      setAuthenticationLogin(false);
    }
  }, [authentication, location.pathname]);

  const { getFavProducts } = useFavourite();

  const getProfile = async () => {
    try {
      const response = await dispatch(fetchProfile());
      const { data, message, status } = response?.payload;

      if (status) {
        setProfileData(data[0]);
        setUserdetails(data[0]);
      } else {
        ToastNotifyError(message);
      }
    } catch {
      ToastNotifyError("Failed to fetch profile");
    }
    getFavProducts();
  };

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const guestuserFlow = async () => {
    await dispatch(fetchGuestUserFlow());
  };

  const handleLogout = () => {
    handleMenuClose();
    dispatch(fetchLogout());
    dispatch(clearAllFav());
    dispatch(resetBag());
    guestuserFlow();
    setTripDetails([]);
    setBagItems([]);
    setUserdetails([]);
    navigate(ROUTE_PATH.HOME);
  };

  const profileCard = (view) => {
    if (view) {
      return (
        <>
          <Box sx={styles.profileButton} onClick={handleMenuOpen}>
            <PersonOutlineRoundedIcon sx={styles.iconBackground} />
            <Typography sx={styles.userName}>Profile</Typography>
            <KeyboardArrowDownRoundedIcon sx={styles.iconBackground} />
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: styles.dropdownMenu,
            }}
          >
            <MenuItem sx={styles.dropDownRow1} onClick={handleMenuClose}>
              {profileData ? (
                <>
                  <Box>
                    <img
                      src={profileData?.profile_picture}
                      alt='pic'
                      width='35px'
                      height='35px'
                      style={{ borderRadius: "50%", objectFit: "cover" }}
                    />
                  </Box>
                  <Box>
                    <Typography sx={styles.dorpDownUserName}>
                      {profileData?.username || "User"}
                    </Typography>
                    <Typography
                      sx={styles.dorpDownViewProfile}
                      onClick={() => navigate(ROUTE_PATH.USER_PROFILE)}
                    >
                      View Profile
                    </Typography>
                  </Box>
                </>
              ) : (
                <>
                  <AccountCircleOutlinedIcon sx={styles.iconProfile} />
                  <Box>
                    <Typography sx={styles.dorpDownUserName}>User</Typography>
                    <Typography
                      sx={styles.dorpDownViewProfile}
                      onClick={() => navigate(ROUTE_PATH.PROFILE)}
                    >
                      Create Profile
                    </Typography>
                  </Box>
                </>
              )}
            </MenuItem>
            <MenuItem sx={styles.dropDownRow2} onClick={handleLogout}>
              <Button
                
                sx={{
                  fontFamily: "Lexend !important",
                  width: "100%",
                  textTransform: "none",
                  border: "1px solid black",
                  color: "#050505",
                  borderRadius: "0px !important",
                  fontSize: "14px",
                  fontWeight: 400,
                }}
              >
                Log out
              </Button>
            </MenuItem>
          </Menu>
        </>
      );
    } else {
      return (
        <Link
          to={ROUTE_PATH.LOGIN}
          aria-label={HOME_PAGE.ariaLabels.login}
          style={styles.link}
        >
          <CustomButton
            ariaLabel={HOME_PAGE.ariaLabels.login}
            category='primary'
            size={CUSTOM_BUTTON_OPTIONS.S4}
            areaLabel={HOME_PAGE.buttonLabels.login}
          >
            {HOME_PAGE.buttonLabels.login}
          </CustomButton>
        </Link>
      );
    }
  };

  return (
    <>
      <AppBar position='sticky' sx={styles.appBar}>
        <Toolbar sx={styles.toolbar(isScrolled)}>
          <Box sx={styles.toolbarContent}>
          <Box sx={styles.hidden}>
            <Box sx={styles.buttonGroup}>
              <Link
                aria-label={HOME_PAGE.ariaLabels.goToAbout}
                to='/about'
                style={styles.link}
              >
                <Typography sx={styles.headingFont}>
                  {HOME_PAGE.buttonLabels.about}
                </Typography>
              </Link>
              <Link
                aria-label={HOME_PAGE.ariaLabels.goToHowItWorks}
                to='/how-it-works'
                style={styles.link}
              >
                <Typography sx={styles.headingFont}>
                  {HOME_PAGE.buttonLabels.howItWorks}
                </Typography>
              </Link>
              <Link
                aria-label={HOME_PAGE.ariaLabels.goToHowItWorks}
                to='https://blog.wanderobe.co/'
                target='_blank'
                rel='noopener noreferrer'
                style={styles.link}
              >
                <Typography sx={styles.headingFont}>
                  Read
                </Typography>
              </Link>
            </Box>
          </Box>

          <IconButton
            aria-label={HOME_PAGE.ariaLabels.showNavigation}
            sx={styles.logo}
            onClick={() => toggleDrawer(true)}
            edge='end'
          >
            <MenuIcon />
          </IconButton>

          <Link
            to={ROUTE_PATH.HOME}
            aria-label={HOME_PAGE.ariaLabels.navigateToLanding}
          >
            <Box
              component='img'
              sx={styles.siteLogo}
              loading='lazy'
              src={WanderobeLogo}
              alt={HOME_PAGE.placeholders.logo}
            />
          </Link>

          <Box sx={styles.buttonGroup}>
            <Link
              style={styles.link}
              to={ROUTE_PATH.BROWSE}
              aria-label={HOME_PAGE.ariaLabels.search}
            >
              <SearchIcon sx={styles.iconBackground} />
              <Typography sx={styles.hidden}>
                {HOME_PAGE.buttonLabels.browse}
              </Typography>
            </Link>
            <Link
              to={ROUTE_PATH.BAG}
              style={styles.link}
              aria-label={HOME_PAGE.ariaLabels.openBag}
            >
              <Box sx={styles.bagIcon}>
              <ShoppingBagOutlinedIcon sx={styles.iconBackground} />
              {bag?.bagItems?.length > 0 && (
                <Box sx={styles.bagCount}>
                  {bag?.bagItems?.reduce((total, item) => total + (item?.quantity || 0), 0)}
                </Box>
              )}
              </Box>
              <Typography sx={styles.hidden}>
                {HOME_PAGE.drawerText.bag}
              </Typography>
            </Link>
            <Box sx={styles.hidden}>
              <Link
                style={styles.link}
                to={ROUTE_PATH.CLOSET}
                aria-label={HOME_PAGE.ariaLabels.goToCloset}
              >
                <CheckroomIcon sx={styles.iconBackground} />
                <Typography sx={styles.headingFont}>
                  {HOME_PAGE.drawerText.myCloset}
                </Typography>
              </Link>
            </Box>
            <Box sx={styles.hidden}>{profileCard(authenticationLogin)}</Box>
          </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor='left'
        open={isDrawerOpen}
        onClose={() => toggleDrawer(false)}
      >
        <Box sx={styles.mobileLayout} role='presentation'>
          <List sx={styles.drawerItemList}>
            <Box sx={styles.drawerHeader}>
              <Button
                sx={styles.iconClass}
                onClick={() => toggleDrawer(false)}
                variant='text'
              >
                <CloseIcon />
              </Button>
              <Link
                to={ROUTE_PATH.HOME}
                onClick={() => toggleDrawer(false)}
                aria-label={HOME_PAGE.ariaLabels.navigateToLanding}
              >
                <Box
                  component='img'
                  sx={styles.logoHeight}
                  src={WanderobeLogo}
                  alt={HOME_PAGE.placeholders.logo}
                  loading='lazy'
                />
              </Link>
            </Box>
            {/* <Box
              aria-label={HOME_PAGE.ariaLabels.search}
              sx={styles.drawerItem}
            >
              <TextField
                variant="outlined"
                fullWidth
                placeholder={HOME_PAGE.placeholders.search}
                sx={styles.inputField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={styles.greycolor} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box> */}
            <Link
              to={ROUTE_PATH.BROWSE}
              onClick={() => toggleDrawer(false)}
              aria-label={HOME_PAGE.ariaLabels.browse}
              style={styles.links}
            >
              <Box
                onClick={() => toggleDrawer(false)}
                aria-label={HOME_PAGE.ariaLabels.browse}
                sx={{ ...styles.drawerItem, ...styles.border2 }}
              >
                <Box sx={styles.drawerItemLi}>
                  <SearchIcon sx={styles.iconBackground} />
                  {HOME_PAGE.drawerText.browse}
                </Box>
                <ChevronRightIcon />
              </Box>
            </Link>
            <Link
              aria-label={HOME_PAGE.ariaLabels.openBag}
              to={ROUTE_PATH.BAG}
              onClick={() => toggleDrawer(false)}
              style={styles.links}
            >
              <Box
                onClick={() => toggleDrawer(false)}
                aria-label={HOME_PAGE.ariaLabels.browse}
                sx={{ ...styles.drawerItem, ...styles.border }}
              >
                <Box sx={styles.drawerItemLi}>
                  <ShoppingBagOutlinedIcon sx={styles.iconBackground} />
                  {HOME_PAGE.drawerText.bag}
                </Box>
                <ChevronRightIcon />
              </Box>
            </Link>
            <Link
              to={ROUTE_PATH.CLOSET}
              onClick={() => toggleDrawer(false)}
              aria-label={HOME_PAGE.ariaLabels.goToCloset}
              style={styles.links}
            >
              <Box
                onClick={() => toggleDrawer(false)}
                aria-label={HOME_PAGE.ariaLabels.goToCloset}
                sx={{ ...styles.drawerItem, ...styles.border }}
              >
                <Box sx={styles.drawerItemLi}>
                  <CheckroomIcon sx={styles.iconBackground} />
                  {HOME_PAGE.drawerText.myCloset}
                </Box>
                <ChevronRightIcon />
              </Box>
            </Link>
            {authenticationLogin ? (
              <Link
                to={ROUTE_PATH.USER_PROFILE}
                onClick={() => toggleDrawer(false)}
                aria-label={HOME_PAGE.ariaLabels.goToMyProfile}
                style={styles.links}
              >
                <Box
                  onClick={() => toggleDrawer(false)}
                  aria-label={HOME_PAGE.ariaLabels.goToMyProfile}
                  sx={{ ...styles.drawerItem, ...styles.border }}
                >
                  <Box sx={styles.drawerItemLi}>
                    <PersonOutlineOutlinedIcon sx={styles.iconBackground} />
                    {HOME_PAGE.drawerText.profile}
                  </Box>
                  <ChevronRightIcon />
                </Box>
              </Link>
            ) : (
              ""
            )}

            <Link
              onClick={() => toggleDrawer(false)}
              aria-label={HOME_PAGE.ariaLabels.goToAbout}
              to={ROUTE_PATH.ABOUT}
              style={styles.links}
            >
              <Typography
                aria-label={HOME_PAGE.ariaLabels.goToAbout}
                sx={{ ...styles.drawerItem, ...styles.border1 }}
              >
                {HOME_PAGE.buttonLabels.about}
              </Typography>
            </Link>
            <Link
              onClick={() => toggleDrawer(false)}
              aria-label={HOME_PAGE.ariaLabels.goToHowItWorks}
              to={ROUTE_PATH.HOW_IT_WORKS}
              style={styles.links}
            >
              <Typography
                aria-label={HOME_PAGE.ariaLabels.goToHowItWorks}
                sx={{ ...styles.drawerItem, ...styles.border3 }}
              >
                {HOME_PAGE.buttonLabels.howItWorks}
              </Typography>
            </Link>
            <Link
              to={ROUTE_PATH.CUSTOMER_SUPPORT}
              onClick={() => toggleDrawer(false)}
              aria-label={HOME_PAGE.ariaLabels.customerSupport}
              style={styles.links}
            >
              <Typography
                aria-label={HOME_PAGE.ariaLabels.customerSupport}
                sx={{
                  ...styles.drawerItem,
                  ...styles.bottomSpace20,
                }}
              >
                {HOME_PAGE.drawerText.customerSupport}
              </Typography>
            </Link>
            <Link
              to='https://blog.wanderobe.co/'
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => toggleDrawer(false)}
              aria-label="blog link"
              style={styles.links}
            >
              <Typography
                aria-label="blog link"
                sx={{
                  ...styles.drawerItem,
                  ...(!authenticationLogin
                    ? styles.bottomSpace20
                    : styles.bottomSpace15),
                }}
              >
                Read
              </Typography>
            </Link>

            {!authenticationLogin && (
              <Box sx={styles.bottomSpace32}>
                <Box sx={{ ...styles.drawerItem1, ...styles.border1 }}>
                  <AccountCircleOutlinedIcon />
                  <Typography>{HOME_PAGE.messages.createAccount}</Typography>
                </Box>
                <Box sx={styles.drawerItem}>
                  <Typography sx={styles.text}>
                    {HOME_PAGE.messages.joinPrompt}
                  </Typography>
                </Box>
              </Box>
            )}
            {/* <Box sx={styles.bottomSpace32}>
              <Box sx={{ ...styles.drawerItem1, ...styles.border1 }}>
                <AccountCircleOutlinedIcon />
                <Typography>{HOME_PAGE.messages.createAccount}</Typography>
              </Box>
              <Box sx={styles.drawerItem}>
                <Typography sx={styles.text}>
                  {HOME_PAGE.messages.joinPrompt}
                </Typography>
              </Box>
            </Box> */}
            {!authenticationLogin ? (
              <>
                <Box sx={styles.drawerItem}>
                  <Link
                    to={ROUTE_PATH.LOGIN}
                    onClick={() => toggleDrawer(false)}
                    aria-label={HOME_PAGE.ariaLabels.login}
                    style={styles.fullWidth}
                  >
                    <CustomButton
                      isFullWidthMobile
                      ariaLabel={HOME_PAGE.ariaLabels.login}
                      category='primary'
                      size={CUSTOM_BUTTON_OPTIONS.S4}
                      areaLabel={HOME_PAGE.buttonLabels.login}
                      className='loginButton'
                    >
                      {HOME_PAGE.buttonLabels.login}
                    </CustomButton>
                  </Link>
                </Box>
                <Box sx={styles.drawerItem}>
                  <Link
                    to={ROUTE_PATH.SIGNUP}
                    onClick={() => toggleDrawer(false)}
                    aria-label={HOME_PAGE.ariaLabels.signup}
                    style={styles.newUser}
                  >
                    {HOME_PAGE.messages.newUser}
                  </Link>
                </Box>
              </>
            ) : (
              ""
            )}
          </List>

          {authenticationLogin && (
            <MenuItem sx={styles.dropDownRow3} onClick={handleLogout}>
              <BorderButton sx={styles.dropDownField}>Log out</BorderButton>
            </MenuItem>
          )}
        </Box>
      </Drawer>
    </>
  );
}

export default NavigationHeader;
